// eslint-disable-next-line aloft/no-sui-chakra, aloft/prefer-sound-ui-box
import { Box } from '@aloft/toolkit-sui/chakra';

import { ReactNode } from 'react';

export const StopColumnDrag = ({ children }: { children: ReactNode }) => (
  <Box display="inline-flex" onPointerDown={(e) => e.stopPropagation()}>
    {children}
  </Box>
);
